import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface MyBillingPartiesData {
    billingParties?: void,
    billingPartiesInMyGroup?: void,
    myBillingParties: {
        data: BillingParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

const GET_MY_BILLING_PARTIES_QUERY = gql`
  query getMyBillingParties($count: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryMyBillingPartiesHasGroupBookingWhereHasConditions, $hasBillingPartyMember: QueryMyBillingPartiesHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    myBillingParties(first: $count, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      data {
        id
        overduePayments
        cost
        outstandingBalance
        hasPendingECheckPayments
        code

        payingMembers {
            id
            primary_paying_member
            first_name
            last_name
            email
        }
        booking {
            id
            start_date
            end_date

            group {
                id
                booking_form_url
                name
                description_checkin

                tour {
                    id
                    display_name
                }

                hotel {
                    id
                    display_name
                }
            }
        }
        members {
            id
        }
      }
      ${gqlPaginatorInfo}
    }
  }
`;

const getMyBillingParties = (count: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any, hasBillingPartyMember?: any) => useQuery<MyBillingPartiesData>(
    GET_MY_BILLING_PARTIES_QUERY,
    {
        variables: {
            count,
            page,
            where,
            hasGroupBooking,
            hasBillingPartyMember,
            orderBy,
        },

    }
);

export default getMyBillingParties;
